export default function dateFormat(data) {
    const inputDateString=isNaN(data)?data:data.toString();
    const utcDateString = `${inputDateString.slice(0, 4)}-${inputDateString.slice(4, 6)}-${inputDateString.slice(6, 8)}T${inputDateString.slice(8, 10)}:${inputDateString.slice(10, 12)}:${inputDateString.slice(12)}Z`;

    const date = new Date(utcDateString);
    const timestamp = date.getTime();
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
  
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');
  
    return {date:`${year}-${month}-${day} ${hours}:${minutes}:${seconds}`,timestamp:timestamp, newDate:new Date(year,month-1,day,hours,minutes,seconds)};
}